export class QtyRequest {
    itemCategoryId: number;
    itemSubCategoryId: number;
    itemId: number;
    sizeId: number;
    unitId: number;
    saleOrderId?: number;
    constructor(itemCategoryId: number, itemSubCategoryId: number, itemId: number, sizeId: number, unitId: number, saleOrderId?: number) {
        this.itemCategoryId = itemCategoryId;
        this.itemSubCategoryId = itemSubCategoryId;
        this.itemId = itemId;
        this.sizeId = sizeId;
        this.unitId = unitId;
        this.saleOrderId = saleOrderId;
    }
}